export default function guestNeedHelpMiddleware(to, from, next) {
    const guestData = JSON.parse(localStorage.getItem('guest_data'));
    const allowedToChooseNeedHelpOption = localStorage.getItem('allowed_to_choose_need_help_option');
    if (guestData &&
        guestData.guest.guest_need_help_flight.length == 0 &&
        allowedToChooseNeedHelpOption == 1) {
        next();
    } else if (guestData.guest.guest_need_help_flight.length > 0) {
        next('/booking-help-details');
    } else {
        next('/error');
    }
}